import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";
import { Checkbox_default } from "./chunk-3HL27OQ6.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableField/CheckableField.Input.tsx
import { forwardRef, useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = Checkbox_default;
var FIELD_INPUT_CLASSNAME_MAP = {};
var CheckableFieldInput = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      "aria-describedby": ariaDescribedBy,
      className
    } = _b,
    rest = __objRest(_b, ["as", "aria-describedby", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    id,
    name,
    description,
    image,
    validation,
    validationMessage,
    badge
  } = useContext(CheckableFieldContext);
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref
  }, rest), {
    id,
    name,
    "aria-labelledby": "".concat(id, "-label"),
    "aria-invalid": validation === "error" ? "true" : void 0,
    "aria-errormessage": validation === "error" && validationMessage ? "".concat(id, "-validation-message") : void 0,
    "aria-describedby": clsx(ariaDescribedBy, {
      ["".concat(id, "-description")]: description && !validationMessage,
      ["".concat(id, "-image")]: image,
      ["".concat(id, "-validation-message")]: validationMessage,
      ["".concat(id, "-badge")]: badge
    }),
    className: clsx("pd:checkable-field__input", className)
  }));
});
var CheckableField_Input_default = CheckableFieldInput;
export { FIELD_INPUT_CLASSNAME_MAP, CheckableField_Input_default };